module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box add-bg"
  }, [_c('div', {
    staticClass: "c-header clearfix"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us"
  }, [_c('h2', [_vm._v("联系我们")]), _c('p', [_vm._v("CONTACT US "), _c('i')]), _c('div', {
    staticClass: "map"
  }, [_c('img', {
    attrs: {
      "src": require("./images/map.png"),
      "alt": "图片加载失败"
    }
  })]), _c('ul', [_c('li', {
    staticClass: "left"
  }, [_c('h2', [_vm._v("联系地址")]), _c('p', [_vm._v("地址:重庆市渝北区金开大道西段106号2幢8层3号")])]), _c('li', [_c('h2', [_vm._v("联系邮箱")]), _c('p', [_vm._v("商务邮箱:bjjrkf@bajiegroup.com")])]), _c('li', {
    staticClass: "left"
  }, [_c('h2', [_vm._v("联系电话")]), _c('p', [_vm._v("客服电话:"), _c('span', [_vm._v("023-88392602")])])]), _c('li', [_c('h2', [_vm._v("邮政编码")]), _c('p', [_vm._v("邮编:400120")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-261a73fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261a73fe","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/contactUs.vue
// module id = 1187
// module chunks = 2